class WallPaperDrawerOpener extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector(".alh-open-drawer__btn");
    this.tooltip = this.querySelector("[data-tooltip]");
    this.titleEl = this.querySelector("[data-text]");
    this.tooltipEls = this.querySelectorAll("[data-wiq-tooltip]");
    this.currentToolTip = null;
    this.totalPriceEl = this.querySelector("[data-total-text]");
    this.selectValueEl = this.querySelector("[data-selected-value]");
    this.measurementsValuesEl = this.querySelector(
      "[data-wi-tooltip='wp-size']"
    );

    this.oldInfo = {
      title: this.title.innerHTML,
      tooltip: this.tooltip.innerHTML,
    };

    if (!this.button) return;
    this.button.addEventListener("click", () => {
      const wallpaperCalculatorSidebar =
        document.querySelector("calculate-sidebar");

      if (wallpaperCalculatorSidebar) {
        wallpaperCalculatorSidebar.open();
      }
    });
  }

  wallpaperMeasurementsUnsubscriber = undefined;
  connectedCallback() {
    document.body.setAttribute("data-measurements-required", "");
    this.wallpaperMeasurementsUnsubscriber = subscribe(
      PUB_SUB_EVENTS.wallpaperMeasurements,
      (event) => {
        this.render(event.data.measurements, event.data.configurator);
        this.renderMeasurementsValues(event.data.configurator);
      }
    );

    this.tooltipEls.forEach((el) => {
      el.addEventListener("click", this.handleTooltip.bind(this));
    });
    document.addEventListener("click", (e) => {
      const target = e.target;
      if (!target.hasAttribute("data-wiq-tooltip")) {
        this.removeAttribute("data-tooltip-open");
        this.currentToolTip = null;
      }
    });
  }

  disconnetedCallback() {
    this.wallpaperMeasurementsUnsubscriber();
  }

  render(measurements) {
    if (!measurements) return;
    this.selectValueEl.innerHTML = measurements.dimensions;
    this.titleEl.innerHTML = "Customize & Order";
    this.tooltip.innerHTML = "Change your wall dimensions.";
    this.totalPriceEl.innerHTML = measurements.subtotalText;
    this.setAttribute("data-active", "");
    document.body.removeAttribute("data-measurements-required");
  }

  renderMeasurementsValues(configurator) {
    var html = [];
    if (configurator.measurements) {
      html.push(
        `<div class="measurement-value-tooltip"><span>Strip width:</span><span>
        ${configurator.print(
          configurator.measurements.strip_width
        )}${configurator.getSymbol("symbol")}
        </span></div>`
      );

      html.push(
        `<div class="measurement-value-tooltip"><span>Strips:</span><span>
        ${configurator.measurements.strips}
        </span></div>`
      );
      html.push(
        `<div class="measurement-value-tooltip"><span>Total Wallpaper width:</span><span>
        ${configurator.print(
          configurator.measurements.wpWidth
        )}${configurator.getSymbol("symbol")}
        </span></div>`
      );
      html.push(
        `<div class="measurement-value-tooltip"><span>Total Wallpaper height:</span><span>
        ${configurator.print(
          configurator.measurements.wpHeight
        )}${configurator.getSymbol("symbol")}
        </span></div>`
      );

      html.push(
        `<div class="measurement-value-tooltip"><span>Width overage:</span><span>
        ${configurator.print(
          configurator.measurements.widthOverage
        )}${configurator.getSymbol("symbol")}
        </span></div>`
      );

      html.push(
        `<div class="measurement-value-tooltip"><span>Height overage:</span><span>
        ${configurator.print(
          configurator.measurements.heightOverage
        )}${configurator.getSymbol("symbol")}
        </span></div>`
      );

      if (this.measurementsValuesEl) {
        this.measurementsValuesEl.dataset.tippyContent = html.join("");
      }
    }
  }

  handleTooltip(event) {
    const target = event.target;
    const tooltip = target.getAttribute("data-wiq-tooltip");
    if (this.currentToolTip == tooltip) {
      this.removeAttribute("data-tooltip-open");
      this.currentToolTip = null;
    } else {
      this.setAttribute("data-tooltip-open", tooltip);
      this.currentToolTip = tooltip;
    }
  }
}
customElements.define("wallpaper-drawer-opener", WallPaperDrawerOpener);

class SurfaceTypeDropdown extends HTMLElement {
  constructor() {
    super();
    this.dropdown = this.querySelector("[data-dropdown]");
    this.selectedEl = this.querySelector("[data-selected-el]");
  }
  connectedCallback() {
    this.dropdown.addEventListener("click", this.handleDropdown.bind(this));
    document.addEventListener("click", (e) => {
      if (!this.dropdown.contains(e.target)) {
        this.removeAttribute("open");
      }
    });
  }

  getSelectedValue() {
    return this.selectedEl.textContent;
  }

  handleDropdown(event) {
    const target = event.target;
    if (target.classList.contains("select-item")) {
      this.selectedEl.innerHTML = target.innerHTML;
      this.dropdown.classList.remove("active");
      this._dispatchEvent();
    }
    this.toggleAttribute("open");
  }

  changevalue(value) {
    this.selectedEl.innerHTML = value;
    this._dispatchEvent();
  }

  _dispatchEvent() {
    this.dispatchEvent(
      new CustomEvent("type-change", {
        detail: { value: this.getSelectedValue() },
      })
    );
  }
}

customElements.define("surface-type-dropdown", SurfaceTypeDropdown);

class ScaleRange extends HTMLElement {
  constructor() {
    super();
    this.scale = this.querySelector('input[name="scale-progress"]');
    this.inputScale = this.querySelector('input[name="scale-input"]');
    this.rangeTextEl = this.querySelector(".slider-range");
    this.min = this.getAttribute("data-min")
      ? parseInt(this.getAttribute("data-min"))
      : 100;
    this.max = this.getAttribute("data-max")
      ? parseInt(this.getAttribute("data-max"))
      : 300;
  }
  connectedCallback() {
    this.scale.addEventListener("input", this.handleScaleChange.bind(this));
    this.inputScale.addEventListener("keypress", this.isNumberKey.bind(this));
    this.inputScale.addEventListener("input", this.handleScaleInput.bind(this));
  }

  isNumberKey(event) {
    let value = event.target.value;
    if (
      (event.which != 46 || value.indexOf(".") != -1) &&
      (event.which < 48 || event.which > 57)
    ) {
      event.preventDefault();
    }
    if (
      value.indexOf(".") != -1 &&
      value.substring(value.indexOf(".")).length > 2
    ) {
      event.preventDefault();
    }
  }

  handleScaleChange() {
    this.inputScale.value = this.scale.value;
    this.fireHook();
  }

  handleScaleInput(event) {
    event.preventDefault();
    var value = parseInt(this.inputScale.value);
    this.inputScale.classList.remove("invalid");
    if (value < this.min) {
      value = this.min;
      this.inputScale.classList.add("invalid");
    } else if (value > this.max) {
      value = this.max;
      this.inputScale.classList.add("invalid");
    }
    this.scale.value = value;

    this.fireHook();
  }

  updateScaleRange(obj) {
    this.min = obj.scale_min;
    this.max = obj.scale_max;
    this.scale.min = this.min;
    this.scale.max = this.max;
  }

  fireHook() {
    this.dispatchEvent(
      new CustomEvent("scale-change", {
        detail: { scale: this.scale.value },
      })
    );
  }
}

customElements.define("scale-range", ScaleRange);

class WIQRuler extends HTMLElement {
  constructor() {
    super();
    this.canvas = this.querySelector("canvas");
    this.ctx = this.canvas.getContext("2d");
  }

  handler(configurator) {
    this.steps = 20;
    this.pixelsPer = 4;
    if (configurator.unit == "cm") {
      this.pixelsPer = 1.57;
      this.steps = 50;
    }

    if (this.dataset.orientation == "vertical") {
      this.renderVertical(configurator);
    } else {
      this.renderHorizontal(configurator);
    }
  }

  renderHorizontal(configurator) {
    const padding = 0;
    const canvas = this.querySelector("canvas");
    const ctx = canvas.getContext("2d");
    canvas.width = configurator.measurements.containerWidth;
    this.maxSteps = Math.ceil(canvas.width / this.pixelsPer);

    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.beginPath();
    ctx.moveTo(padding, canvas.height);
    ctx.lineTo(canvas.width, canvas.height);
    ctx.lineWidth = 2;
    ctx.stroke();

    for (let i = 0; i <= this.maxSteps; i += this.steps) {
      const x = padding + i * this.pixelsPer;
      ctx.beginPath();
      ctx.lineWidth = 2;
      ctx.moveTo(x, canvas.height - 10);
      ctx.lineTo(x, canvas.height);
      ctx.stroke();

      ctx.font = "12px Arial";
      ctx.fillStyle = "#333";
      ctx.textAlign = "center";
      ctx.fillText(
        `${i}${configurator.getSymbol("symbol")}`,
        x,
        canvas.height - 12
      );
      for (let j = 1; j < this.steps; j++) {
        const x = padding + (i + j) * this.pixelsPer;
        if (configurator.unit == "cm") {
          if (j % 5 != 0) {
            continue;
          }
        }
        ctx.beginPath();
        ctx.lineWidth = 1;
        ctx.moveTo(x, canvas.height - 7);
        ctx.lineTo(x, canvas.height);
        ctx.stroke();
      }
    }
  }

  renderVertical(configurator) {
    this.steps = 20;
    this.pixelsPer = 4;
    if (configurator.unit == "cm") {
      this.pixelsPer = 1.57;
      this.steps = 50;
    }

    const padding = 0;
    const canvas = this.querySelector("canvas");
    const ctx = canvas.getContext("2d");
    canvas.height = configurator.measurements.containerHeight;
    this.maxSteps = Math.ceil(canvas.height / this.pixelsPer);

    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.beginPath();
    ctx.moveTo(canvas.width, padding);
    ctx.lineTo(canvas.width, canvas.height);
    ctx.lineWidth = 2;
    ctx.stroke();

    for (let i = 0; i <= this.maxSteps; i += this.steps) {
      const y = padding + i * this.pixelsPer;
      ctx.beginPath();
      ctx.lineWidth = 2;
      ctx.moveTo(canvas.width, y);
      ctx.lineTo(canvas.width - 10, y);
      ctx.stroke();

      ctx.font = "12px Arial";
      ctx.fillStyle = "#333";
      ctx.textAlign = "right";
      ctx.save();
      ctx.translate(canvas.width - 12, y);
      ctx.rotate(-Math.PI / 2);
      ctx.fillText(`${i}${configurator.getSymbol("symbol")}`, 0, 0);
      ctx.restore();

      for (let j = 1; j < this.steps; j++) {
        const y = padding + (i + j) * this.pixelsPer;
        if (configurator.unit == "cm") {
          if (j % 5 != 0) {
            continue;
          }
        }
        ctx.beginPath();
        ctx.lineWidth = 1;
        ctx.moveTo(canvas.width, y);
        ctx.lineTo(canvas.width - 7, y);
        ctx.stroke();
      }
    }
  }
}

customElements.define("wiq-ruler", WIQRuler);

class WallPaperCalculator extends HTMLElement {
  constructor() {
    super();
    this.unit = "inch";
    this.measurements = {};
    this.cropper = null;
    this.surfaceDropdown = this.querySelector("surface-type-dropdown");
    this.surfaceList = Array.from(
      this.querySelectorAll(".measure-surface-list li")
    );
    this.unitInput = Array.from(
      this.querySelectorAll('input[name="unit-type"]')
    );
    this.actionBtns = this.querySelectorAll("[data-action]");
    this.widthInput = this.querySelector('input[name="width-input"]');
    this.heightInput = this.querySelector('input[name="height-input"]');
    this.scaleRange = this.querySelector("scale-range");
    this.toolbarCheckboxes = this.querySelectorAll('input[name="toolbar[]"');
    this.imageConfigs = {};
    this.imageConfig = null;
    this.cropperEl = this.querySelector("[data-pi-cropper-image]");
    this.rulerEls = this.querySelectorAll("wiq-ruler");
    this.inputUnitSuffix = this.querySelectorAll("[data-input-unit-suffix]");
    this.initEvents();
  }
  variantChangeUnsubscriber = undefined;
  connectedCallback() {
    const image_File = this.querySelector("[data-images-files]");
    if (image_File) {
      this.imageConfigs = JSON.parse(image_File.innerHTML).variants;
    }

    this.variantChangeUnsubscriber = subscribe(
      PUB_SUB_EVENTS.variantChange,
      (event) => {
        this.currentVariant = event.data.variant;
        this.setCanvas().then(() => {
          this.handleCalculation();
        });
      }
    );
    this.currentVariant = document
      .querySelector("variant-selects")
      ?.getCurrentVariant();
    this.handleUnitChange({});
    this.customizerGridAndStrips();
    this.prefillData();
  }

  initEvents() {
    this.surfaceDropdown.addEventListener(
      "type-change",
      this.handleTypeChange.bind(this)
    );
    this.surfaceList.forEach((el) => {
      el.addEventListener("click", () => {
        this.surfaceDropdown.changevalue(el.textContent);
      });
    });
    this.unitInput.forEach((el) => {
      el.addEventListener("change", this.handleUnitChange.bind(this));
    });

    this.actionBtns.forEach((el) => {
      el.addEventListener("click", this.handleAction.bind(this));
    });

    [this.widthInput, this.heightInput].forEach((el) => {
      el.addEventListener("keypress", this.isNumberKey.bind(this));
      el.addEventListener("input", this.handleMeasurementsInput.bind(this));
    });

    this.scaleRange.addEventListener(
      "scale-change",
      this.handleZoomChange.bind(this)
    );
    this.toolbarCheckboxes.forEach((el) => {
      el.addEventListener("change", this.customizerGridAndStrips.bind(this));
    });
  }

  cropBoxScale() {
    const n = this.measurements.containerHeight / 2.5;
    const pixelWidth = this.measurements.wpWidth * 0.0254 * n;
    const pixelHeight = this.measurements.wpHeight * 0.0254 * n;
    if (
      pixelWidth <= this.measurements.containerWidth &&
      pixelHeight <= this.measurements.containerHeight
    ) {
      return 1;
    }
    const scaleWidthFactor = this.measurements.containerWidth / pixelWidth;
    const scaleHeightFactor = this.measurements.containerHeight / pixelHeight;
    return Math.min(scaleWidthFactor, scaleHeightFactor);
  }

  pixelsPerMeter() {
    return 39.3701 * 4;
  }

  scaleImageWidth() {
    return (
      this.pixelsPerMeter() /
      (this.imageConfig.width / this.imageConfig.widthMeter)
    );
  }
  scaleImageHeight() {
    return (
      this.pixelsPerMeter() /
      (this.imageConfig.height / this.imageConfig.heightMeter)
    );
  }

  setCanvas() {
    const imageConfig = this.imageConfigs[this.currentVariant.id];
    if (!imageConfig) {
      return new Promise((resolve, reject) => {
        resolve();
      });
    }
    this.imageConfig = imageConfig;

    this.imageConfig.widthMeter = parseFloat(this.imageConfig.widthMeter);
    this.imageConfig.heightMeter = parseFloat(this.imageConfig.heightMeter);
    this.imageConfig.scale_min = parseInt(this.imageConfig.scale_min);
    this.imageConfig.scale_max = parseInt(this.imageConfig.scale_max);

    this.scaleRange.updateScaleRange(this.imageConfig);

    return new Promise((resolve, reject) => {
      const image = new Image();
      image.src = imageConfig.src;
      image.crossOrigin = "anonymous";
      image.onload = () => {
        const newCanvas = document.createElement("canvas");
        const newctx = newCanvas.getContext("2d");
        this.imageConfig.width = image.width;
        this.imageConfig.height = image.height;

        newCanvas.width = image.width * this.scaleImageWidth();
        newCanvas.height = image.height * this.scaleImageHeight();

        console.log(this.scaleImageWidth(), this.scaleImageHeight());

        this.imageConfig.newWidth = newCanvas.width;
        this.imageConfig.newHeight = newCanvas.height;

        newctx.drawImage(
          image,
          0,
          0,
          image.width,
          image.height,
          0,
          0,
          newCanvas.width,
          newCanvas.height
        );
        const canvasPixelWidth = this.measurements.containerWidth * 3;
        const canvasPixelHeight = this.measurements.containerHeight * 3;
        this.cropperEl.width = canvasPixelWidth;
        this.cropperEl.height = canvasPixelHeight;
        const ctx = this.cropperEl.getContext("2d");
        ctx.width = canvasPixelWidth;
        ctx.height = canvasPixelHeight;
        ctx.fillStyle = ctx.createPattern(newCanvas, "repeat");
        ctx.rect(0, 0, canvasPixelWidth, canvasPixelHeight);
        ctx.fill();
        resolve();
      };
    });
  }

  open() {
    this.setAttribute("open", "");
    document.body.classList.add("no-scroll");
  }

  close() {
    this.removeAttribute("open");
    document.body.classList.remove("no-scroll");
  }

  getLocalStorageMeasurements() {
    const measurements = localStorage.getItem("wiq_measurements");
    if (measurements) {
      return JSON.parse(measurements)[this.dataset.productId];
    }
    return false;
  }
  setLocalStorageMeasurements(inputData) {
    const measurements = localStorage.getItem("wiq_measurements");
    let data = {};
    if (measurements) {
      data = JSON.parse(measurements);
    }
    data[this.dataset.productId] = inputData;
    localStorage.setItem("wiq_measurements", JSON.stringify(data));
  }

  prefillData() {
    const measurements = this.getLocalStorageMeasurements();
    if (!measurements) return;
    this.widthInput.value = measurements.width;
    this.heightInput.value = measurements.height;
    this.scaleRange.scale.value = measurements.scaleValue;
    this.scaleRange.inputScale.value = measurements.scaleValue;
    this.surfaceDropdown.changevalue(measurements.surfaceType);
    this.measurements.canvasData = measurements.canvasData;

    this.unitInput.forEach((el) => {
      if (el.value === measurements.unit) {
        el.checked = true;
      }
    });
    this.unit = this.unitInput.find((el) => el.checked).value;
    if (this.unit == "cm") {
      this.inputUnitSuffix.forEach((el) => {
        el.textContent = "cm";
      });
    } else {
      this.inputUnitSuffix.forEach((el) => {
        el.textContent = "in";
      });
    }
    this.widthInput.dispatchEvent(new Event("input"));
  }

  fireHooks() {
    publish(PUB_SUB_EVENTS.wallpaperMeasurements, {
      data: {
        measurements: this.measurements,
        configurator: this,
      },
    });
  }

  handleTypeChange(event) {
    const value = event.detail.value;
    this.measurements.surfaceType = value;
    this.surfaceList.forEach((el) => {
      if (el.textContent == value) {
        el.classList.add("active");
      } else {
        el.classList.remove("active");
      }
    });
    this.querySelectorAll("[data-surface-type]").forEach((el) => {
      if (el.dataset.surfaceType === value) {
        el.removeAttribute("hidden");
      } else {
        el.setAttribute("hidden", "");
      }
    });
  }

  handleUnitChange(event) {
    this.unit = this.unitInput.find((el) => el.checked).value;
    if (this.unit == "cm") {
      this.inputUnitSuffix.forEach((el) => {
        el.textContent = "cm";
      });
    } else {
      this.inputUnitSuffix.forEach((el) => {
        el.textContent = "in";
      });
    }

    this.handleCalculation();
  }

  handleAction(event) {
    event.preventDefault();
    const target = event.target;
    const action = target.dataset.action;
    if (action == "empty") {
      this.isMeasurementValid()
        ? (this.dataset.view = "preview")
        : (this.dataset.view = "empty");
    } else if (action == "measurements") {
      this.dataset.view = "measurements";
    } else if (action == "preview") {
      this.dataset.view = "preview";
    } else if (action == "close") {
      this.close();
    } else if (action == "save") {
      this.setLocalStorageMeasurements({
        width: this.measurements.width,
        height: this.measurements.height,
        unit: this.unit,
        surfaceType: this.measurements.surfaceType,
        scaleValue: this.scaleRange.scale.value,
      });
      const formBtn = document.querySelector(
        `form#${this.dataset.formId} button[name="add"]`
      );

      if (formBtn) {
        formBtn.click();
      }
      target.setAttribute("disabled", "");

      setTimeout(() => {
        this.close();
        target.removeAttribute("disabled");
        this.renderInputProperties(true);
      }, 500);
    }
  }

  isNumberKey(event) {
    let value = event.target.value;
    if (
      (event.which != 46 || value.indexOf(".") != -1) &&
      (event.which < 48 || event.which > 57)
    ) {
      event.preventDefault();
    }
    if (
      value.indexOf(".") != -1 &&
      value.substring(value.indexOf(".")).length > 2
    ) {
      event.preventDefault();
    }
  }

  convertTo(fromUnit, toUnit, value, round = false) {
    if (toUnit == "meter") {
      toUnit = "m";
    } else if (toUnit == "feet") {
      toUnit = "ft";
    }

    const conversions = {
      cm: {
        cm: 1,
        inch: 0.393701,
        ft: 0.0328084,
        m: 0.01,
      },
      inch: {
        cm: 2.54,
        inch: 1,
        ft: 0.0833333,
        m: 0.0254,
      },
      m: {
        cm: 100,
        inch: 39.3701,
        ft: 3.28084,
        m: 1,
      },
      ft: {
        cm: 30.48,
        inch: 12,
        ft: 1,
        m: 0.3048,
      },
    };
    const result = value * conversions[fromUnit][toUnit];
    return round ? Math.ceil(result * 100) / 100 : result;
  }

  roundUp(value) {
    return Math.ceil(value * 100) / 100;
  }

  print(value) {
    return value.toFixed(2);
  }

  getSymbol(type = "") {
    if (type === "") return this.unit === "inch" ? '"' : "cm";
    return this.unit === "inch" ? '"' : " cm";
  }

  toFootAndIn(value) {
    value = this.convertTo(this.unit, "inch", value);
    let foot = Math.floor(value / 12);
    let remainingInch = Math.round(value % 12);
    return `${foot}' ${remainingInch}"`;
  }

  handleMeasurementsInput(event) {
    const target = event.target;
    const name = event.target.name;
    var value = target.value == "" ? 0 : parseFloat(target.value);
    var invalid = false;

    if (name === "height-input") {
      if (this.unit == "cm" && value < 50) {
        invalid = true;
      } else if (this.unit == "inch" && value < 20) {
        invalid = true;
      }
    }

    if (invalid) {
      target.classList.add("invalid");
      this.dataset.view = "empty";
      this.renderInputProperties(false);
      if (this.cropper) this.cropper.destroy();
    } else {
      target.classList.remove("invalid");
    }

    this.handleCalculation();
  }

  isMeasurementValid() {
    const width = parseFloat(this.widthInput.value);
    const height = parseFloat(this.heightInput.value);

    if (isNaN(width) || isNaN(height)) {
      return false;
    }

    if (this.unit === "cm") {
      if (height < 50) return false;
    } else {
      if (height < 20) return false;
    }

    return true;
  }

  handleCalculation() {
    this.measurements.width = parseFloat(this.widthInput.value);
    this.measurements.height = parseFloat(this.heightInput.value);

    if (isNaN(this.measurements.width) || isNaN(this.measurements.height))
      return;

    if (this.unit === "cm") {
      if (this.measurements.height < 50) return;
    } else {
      if (this.measurements.height < 20) return;
    }

    if (!this.currentVariant) return;

    if (this.currentVariant.options.includes("Vinyl")) {
      this.measurements.strip_width = this.convertTo("cm", this.unit, 60);
    } else {
      this.measurements.strip_width = this.convertTo("cm", this.unit, 48.7);
    }

    this.measurements.overage = this.convertTo("cm", this.unit, 25.4);

    this.measurements.strips = Math.ceil(
      (this.measurements.width + this.measurements.overage) /
        this.measurements.strip_width
    );

    this.measurements.wpWidth =
      this.measurements.strips * this.measurements.strip_width;
    this.measurements.wpHeight =
      this.measurements.height + this.measurements.overage;
    this.measurements.widthOverage =
      this.measurements.wpWidth - this.measurements.width;
    this.measurements.heightOverage =
      this.measurements.wpHeight - this.measurements.height;

    this.renderSideBarInfo();
    this.renderPreview();
    this.setCanvas().then(() => {
      this.initCropperJS();
    });
    this.drawRuler();
    this.calculatePrice();
    this.dataset.view = "preview";
    this.fireHooks();
  }

  initCropperJS() {
    if (this.cropper) this.cropper.destroy();
    this.setAttribute("data-cropper-loading", "");
    this.cropper = new Cropper(this.cropperEl, {
      dragMode: "move",
      viewMode: 3,
      movable: true,
      autoCrop: 1,
      autoCropArea: 1,
      cropBoxMovable: false,
      cropBoxResizable: false,
      toggleDragModeOnDblclick: false,
      background: false,
      scalable: true,
      zoomable: false,
      guides: false,
      highlight: false,
      center: false,
      modal: false,
      minContainerWidth: 70,
      minContainerHeight: 70,
      ready: (event) => {
        var n = {
          left: 0,
          top: 0,
          width: this.cropperEl.width,
          height: this.cropperEl.height,
        };

        this.cropper.setCanvasData(n);
        this.handleZoomChange();
        this.drawRuler();
        this.removeAttribute("data-cropper-loading");
      },
      crop: (event) => {
        const newWidth = this.imageConfig.newWidth * this.measurements.scale;
        const newHeight = this.imageConfig.newHeight * this.measurements.scale;

        var image_x_offset = ((event.detail.x % newWidth) / newWidth) * 100;
        var image_y_offset = ((event.detail.y % newHeight) / newHeight) * 100;

        console.log(image_x_offset, image_y_offset, newWidth);

        this.renderInputProperties(true);
      },
    });
  }

  handleZoomChange() {
    var scale = this.scaleRange.scale.value / 100;
    this.measurements.scale = scale;
    this.cropper.scale(scale);
  }

  customizerGridAndStrips() {
    this.measurements.topBar = Array.from(this.toolbarCheckboxes)
      .filter((el) => el.checked)
      .map((el) => el.value);

    ["rulers", "strips"].forEach((value) =>
      this.removeAttribute(`data-${value}`)
    );

    this.measurements.topBar.forEach((value) =>
      this.setAttribute(`data-${value}`, "")
    );
  }

  renderSideBarInfo() {
    this.querySelectorAll("[data-p-strip-width").forEach((el) => {
      el.innerHTML = `${this.print(
        this.measurements.strip_width
      )}${this.getSymbol("symbol")}`;
    });

    this.querySelectorAll("[data-p-strip-count]").forEach((el) => {
      el.innerHTML = this.measurements.strips;
    });

    this.querySelectorAll("[data-p-wpwidth]").forEach((el) => {
      el.innerHTML = `${this.print(this.measurements.wpWidth)}${this.getSymbol(
        "symbol"
      )}`;
    });

    this.querySelectorAll("[data-p-wpheight]").forEach((el) => {
      el.innerHTML = `${this.print(this.measurements.wpHeight)}${this.getSymbol(
        "symbol"
      )}`;
    });

    this.querySelectorAll("[data-p-width-overage]").forEach((el) => {
      el.innerHTML = `${this.print(
        this.measurements.widthOverage
      )}${this.getSymbol("symbol")}`;
    });

    this.querySelectorAll("[data-p-height-overage]").forEach((el) => {
      el.innerHTML = `${this.print(
        this.measurements.heightOverage
      )}${this.getSymbol("symbol")}`;
    });

    this.measurements.dimensions = `${this.print(
      this.measurements.wpWidth
    )}${this.getSymbol("symbol")} w x ${this.print(
      this.measurements.wpHeight
    )}${this.getSymbol("symbol")} h`;
  }

  renderPreview() {
    var stripsHtml = "";
    const pixelPerM = this.pixelsPerMeter();
    const width =
      this.convertTo(this.unit, "m", this.measurements.wpWidth) * pixelPerM;
    const height =
      this.convertTo(this.unit, "m", this.measurements.wpHeight) * pixelPerM;

    this.measurements.containerWidth = width;
    this.measurements.containerHeight = height;
    const strips_width =
      this.convertTo(this.unit, "m", this.measurements.strip_width) * pixelPerM;

    for (let i = 1; i <= this.measurements.strips; i++) {
      let className = "";
      if (i == 1) {
        className = "first";
      } else if (i == this.measurements.strips) {
        className = "last";
      }
      stripsHtml += `<div class="alh-container-grid-item"><div class="alh-num-location ${className}"><span>${i}</span></div></div>`;
    }
    stripsHtml += `<div class="grid-overlay"></div>`;

    const previewContainer = this.querySelector(
      ".wallpaper-preview__container"
    );
    if (previewContainer) {
      previewContainer.style.height = `${height + 180}px`;
      previewContainer.style.minHeight = `${height + 180}px`;
      previewContainer.style.maxHeight = `${height + 180}px`;
    }

    this.querySelectorAll("[data-preview-canvas]").forEach((el) => {
      let stripsWrapEl = el.querySelector(".alh-container-grid-items");
      el.style.setProperty("--wiq-width", `${width}px`);
      el.style.setProperty("--wiq-height", `${height}px`);
      el.style.setProperty("--wiq-strips", this.measurements.strips);
      el.style.setProperty("--wiq-strip-width", `${strips_width}px`);

      stripsWrapEl.innerHTML = stripsHtml;
    });
  }

  renderInputProperties(render) {
    const formId = this.dataset.formId;
    var html = [];

    if (render) {
      const canvasData = this.cropper.getData();

      const newWidth = this.imageConfig.newWidth * canvasData.scaleX;
      const newHeight = this.imageConfig.newHeight * canvasData.scaleX;
      const _image_x = ((canvasData.x % newWidth) / newWidth) * 100;
      const _image_y = ((canvasData.y % newHeight) / newHeight) * 100;

      const wm = this.convertTo(this.unit, "m", this.measurements.wpWidth);
      const hm = this.convertTo(this.unit, "m", this.measurements.wpHeight);

      const unit = this.unit == "cm" ? "cm" : "in";

      const sqm = this.uniteAccordingToMarket("metric");
      const sqft = this.uniteAccordingToMarket("imperial");

      html.push(
        `<input type="hidden" name="properties[Wallpaper Width]" value="${this.print(
          this.measurements.wpWidth
        )} ${unit}" form="${formId}" />`
      );
      html.push(
        `<input type="hidden" name="properties[Wallpaper Height]" value="${this.print(
          this.measurements.wpHeight
        )} ${unit}" form="${formId}" />`
      );
      html.push(
        `<input type="hidden" name="properties[_time]" value="${Date.now()}" form="${formId}" />`
      );
      html.push(
        `<input type="hidden" name="properties[_wall_width]" value="${this.measurements.width} ${unit}" form="${formId}" />`
      );
      html.push(
        `<input type="hidden" name="properties[_wall_height]" value="${this.measurements.height} ${unit}" form="${formId}" />`
      );
      html.push(
        `<input type="hidden" name="properties[Scale]" value="${Math.round(
          canvasData.scaleX * 100
        )} %" form="${formId}" />`
      );
      html.push(
        `<input type="hidden" name="properties[_zoom]" value="${canvasData.scaleX}" form="${formId}" />`
      );
      html.push(
        `<input type="hidden" name="properties[Quantity]" value="${sqft.area} ${
          sqft.areaUnit
        } (${this.print(sqm.area)} ${sqm.areaUnit})" form="${formId}" />`
      );
      html.push(
        `<input type="hidden" name="properties[_unit]" value="${this.unit}" form="${formId}" />`
      );
      html.push(
        `<input type="hidden" name="properties[_image_x]" value="${_image_x}" form="${formId}" />`
      );
      html.push(
        `<input type="hidden" name="properties[_image_y]" value="${_image_y}" form="${formId}" />`
      );
      html.push(
        `<input type="hidden" name="properties[_wm]" value="${wm}" form="${formId}" />`
      );
      html.push(
        `<input type="hidden" name="properties[_hm]" value="${hm}" form="${formId}" />`
      );
      html.push(
        `<input type="hidden" name="properties[_strips]" value="${this.measurements.strips}" form="${formId}" />`
      );
      html.push(
        `<input type="hidden" name="quantity" value="${this.measurements.quantity}" form="${formId}" />`
      );
    }
    const propertiesEl = document.querySelector("[data-form-properties]");
    if (propertiesEl) {
      propertiesEl.innerHTML = html.join("");
    }
  }

  // uniteAccordingToMarket: pass "metric" or "imperial" to force,
// or leave empty to read from data-country on the body tag (set via localization.country.iso_code)
uniteAccordingToMarket(country = false) {
  if (!country) {
    country = document.body.dataset.country;
  }
  const imperialCountries = ["US", "CA"];
  if (!imperialCountries.includes(country)) {
    const sqmArea = this.roundUp(this.measurements.quantity * 0.092903);
    const sqmPrice = this.currentVariant.price * 10.7639;
    return {
      pricePerUnit: sqmPrice,
      area: sqmArea,
      areaUnit: "m²",
    };
  }
  return {
    pricePerUnit: this.currentVariant.price,
    area: this.measurements.quantity,
    areaUnit: "sq ft",
  };
}

  calculatePrice() {
    var priceUnit = "feet";
    const widthFeet = this.convertTo(
      this.unit,
      priceUnit,
      this.measurements.wpWidth
    );
    const heightFeet = this.convertTo(
      this.unit,
      priceUnit,
      this.measurements.wpHeight
    );
    this.measurements.area = widthFeet * heightFeet;
    this.measurements.quantity = Math.ceil(this.measurements.area);
    this.measurements.totalPrice =
      this.measurements.quantity * this.currentVariant.price;

    var { pricePerUnit, area, areaUnit } = this.uniteAccordingToMarket();

    this.measurements.subtotalText = `<strong>Subtotal:</strong> ${area} ${areaUnit} x 
    ${Shopify.formatMoney(
      pricePerUnit,
      cartStrings.money_format
    )} ≈ ${Shopify.formatMoney(
      this.measurements.totalPrice,
      cartStrings.money_format
    )}`;

    this.querySelectorAll("[data-p-total-area]").forEach((el) => {
      el.innerHTML = `${area} ${areaUnit}`;
    });

    this.querySelectorAll("[data-p-total-price]").forEach((el) => {
      el.innerHTML = `${Shopify.formatMoney(
        this.measurements.totalPrice,
        cartStrings.money_format
      )}`;
    });
  }

  drawRuler() {
    this.rulerEls.forEach((el) => {
      el.handler(this);
    });
  }
}

customElements.define("calculate-sidebar", WallPaperCalculator);

document.addEventListener("DOMContentLoaded", () => {
  tippy.setDefaultProps({
    theme: "light",
    allowHTML: true,
  });
  tippy("[data-tippy-content]", {
    trigger: "click",
  });
});